// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".show-more-gallery[data-v-6b66fb28]{position:relative}.show-more-gallery[data-v-6b66fb28]:after{align-content:center;background:rgba(0,0,0,.8);bottom:0;color:#fff;content:attr(data-gallery-lenght);display:grid;font-size:2rem;left:0;position:absolute;right:0;text-align:center;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
